// extracted by mini-css-extract-plugin
module.exports = {"links":"miniLinks_links__33v9R","text":"miniLinks_text__2OnOA"};